import { zh } from "./translations/zh"
import { en } from "./translations/en"
import { ja } from "./translations/ja"
import { ko } from "./translations/ko"

export const languages = {
  zh: {
    name: "中文",
    flag: "🇨🇳",
    code: "CN",
  },
  en: {
    name: "English",
    flag: "🇺🇸",
    code: "US",
  },
  ja: {
    name: "日本語",
    flag: "🇯🇵",
    code: "JP",
  },
  ko: {
    name: "한국어",
    flag: "🇰🇷",
    code: "KR",
  },
} as const

export type Language = keyof typeof languages

export const translations = {
  zh,
  en,
  ja,
  ko,
} as const

export type TranslationKey = keyof typeof translations.zh

/**
 * 获取浏览器语言的辅助函数
 * @returns 检测到的语言代码
 */
export function getBrowserLanguage(): Language {
  if (typeof window === "undefined") {
    return "zh"
  }

  const browserLang = navigator.language.toLowerCase()

  // 语言映射
  if (browserLang.startsWith("zh")) return "zh"
  if (browserLang.startsWith("en")) return "en"
  if (browserLang.startsWith("ja")) return "ja"
  if (browserLang.startsWith("ko")) return "ko"

  // 默认返回中文
  return "zh"
}
